// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://pfureawvtrdiyqcraaaw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBmdXJlYXd2dHJkaXlxY3JhYWF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2MDQ0ODEsImV4cCI6MjA3MjE4MDQ4MX0.jJCx_KSkk6qurcU1QO0vhdCLFgtjmdnYL3elHW91dm0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});